/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ios_SubInputs */

const de__field_ios_sub = /** @type {(inputs: _Field_Ios_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IOS-Pushnotification ID`)
};

/**

* @param {_Field_Ios_SubInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_ios_sub = /** @type {((inputs?: _Field_Ios_SubInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ios_SubInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ios_sub(inputs)
});